import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Sidebar from "../../../../partials/aside/Sidebar";
import helperSpinner from "../../../../../helpers/spinner";
import httpService from "../../../../../services/httpServices/httpServices";
import helpersTime from "../../../../../helpers/time";
import helpersNumber from "../../../../../helpers/numbers";
import StateSiteUserPublisher from "./../StateSiteUserPublisher";
import TitleBar from "../../../../partials/content/TitleBar";
import Pagination from "../../../../partials/content/Pagination";

export default function AllPrivateNotification() {
  const params = useParams();
  const [userID, setUserID] = useState();
  const [allPrivateNotification, setAllPrivateNotification] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);

  useEffect(() => {
    getAllPrivateNotification();
  }, [currentPage, countItemPerPage, userID]);

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getAllPrivateNotification = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultAllPrivateNotification =
      await sendRequestGetAllPrivateNotification(searchFilterQuery);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultAllPrivateNotification) {
      return;
    }

    setCountPage(resultAllPrivateNotification.count_page);
    setAllPrivateNotification(
      resultAllPrivateNotification.private_notifications
    );
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (userID) {
      searchFilterQuery = `${searchFilterQuery}&user_id=${userID}`;
    }

    return searchFilterQuery;
  };

  const sendRequestGetAllPrivateNotification = async (searchFilterQuery) => {
    const headersRequest = getHeaderForRequest();
    let resultRequest;
    try {
      resultRequest = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/private-notification/manage?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return resultRequest.data.data;
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const generateTableAllPrivateNotification = () => {
    return (
      <>
        <div class="container-fluid pb-2">
          <div class="row border border-1 rounded py-2">
            <div class="col-12 col-md-4">
              <div>
                <label>جستجو در شماره کاربری</label>
              </div>
              <div>
                <input
                  className="form-control"
                  type="number"
                  onWheel={(event) => event.currentTarget.blur()}
                  placeholder=" شماره کاربری را در اینجا وارد کنید "
                  onKeyUp={(e) => setUserID(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space m-0">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره</td>
                <td>شماره کاربری</td>
                <td>عنوان</td>
                <td>دیده شده</td>
                <td>فعال</td>
                <td>تاریخ درج</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {allPrivateNotification.map((privateNotification, index) => {
                return (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{privateNotification.pno_id}</td>
                    <td>{privateNotification.pno_user_id}</td>
                    <td>{privateNotification.pno_title}</td>
                    <td>
                      {privateNotification.pno_seen ? (
                        <span className="badge badge-success">دیده شده</span>
                      ) : (
                        <span className="badge badge-danger">دیده نشده</span>
                      )}
                    </td>
                    <td>
                      {privateNotification.pno_active ? (
                        <span className="badge badge-success">فعال</span>
                      ) : (
                        <span className="badge badge-danger">غیرفعال</span>
                      )}
                    </td>
                    <td>
                      {helpersNumber.toPersianNum(
                        helpersTime.convertGregorianToJalali(
                          privateNotification.pno_created_at
                        ) +
                          " " +
                          privateNotification.pno_created_at.split(" ")[1]
                      )}
                    </td>
                    <td>
                      <Link
                        to={`/user/notification-private/edit/${privateNotification.pno_id}`}
                        className="btn btn-success"
                      >
                        <i className="fa fa-edit"></i>
                      </Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {countPage > 1 ? generatePagination() : <></>}
      </>
    );
  };

  const generateButtonAddPrivateNotification = () => {
    return (
      <div className="text-center text-md-right pt-2">
        <Link to="/user/notification-private/add" className="btn btn-success">
          <span className="pl-2">
            <i className="fa fa-plus"></i>
          </span>
          <span>اضافه کردن پیام های خصوصی کاربران</span>
        </Link>
      </div>
    );
  };

  return (
    <>
      <Sidebar openItem="users" activeItem="all-notification-private" />

      <div className="content-wrapper">
        <TitleBar title="پیام های خصوصی کاربران" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div>
                {allPrivateNotification.length == 0 && userID == null ? (
                  <>
                    <div className="pb-2">
                      {generateButtonAddPrivateNotification()}
                    </div>
                    <div className="alert alert-info">
                      هیچ پیام خصوصی برای کاربران نداریم.
                    </div>
                  </>
                ) : (
                  <>
                    <div className="pb-2">
                      {generateButtonAddPrivateNotification()}
                    </div>
                    {generateTableAllPrivateNotification()}
                  </>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
